import { createFileRoute } from '@tanstack/react-router'
import { BookOpen, Compass, Flame, Home, Orbit, Sparkles, Waypoints } from 'lucide-react'

import { KnowledgeCategoryTile } from '@/features/knowledge/components/knowledge-category-tile'
import { useCopy } from '@/lib/copy/use-copy'

export const Route = createFileRoute('/wiedza')({
  component: WiedzaLanding,
})

function WiedzaLanding() {
  const { shell } = useCopy()
  const k = shell.knowledge

  return (
    <section className="space-y-5 p-5">
      <header className="flex items-start justify-between gap-3">
        <span className="font-mono text-hint tracking-[1.3px] text-element-primary uppercase">
          {k.libraryEyebrow}
        </span>
        <div className="font-mono text-hint tracking-[1.3px] text-element-ink-mute">
          V · MMXXVI
        </div>
      </header>

      <div>
        <h1 className="font-display text-[30px] leading-[1.05] text-element-ink italic">
          {k.libraryTitle}
        </h1>
        <p className="mt-2 text-hint leading-[1.5] text-element-ink-dim">{k.librarySubtitle}</p>
      </div>

      <div className="grid grid-cols-2 gap-2.5">
        <KnowledgeCategoryTile
          href="/wiedza/numerologia"
          icon={BookOpen}
          title={k.sectionNumerology}
          hint={k.categoryNumerologyHint}
          count={k.categoryNumerologyCount}
        />
        <KnowledgeCategoryTile
          href="/wiedza/zodiak"
          icon={Compass}
          title={k.sectionZodiac}
          hint={k.categoryZodiacHint}
          count={k.categoryZodiacCount}
        />
        <KnowledgeCategoryTile
          href="/wiedza/chinski"
          icon={Sparkles}
          title={k.sectionChinese}
          hint={k.categoryChineseHint}
          count={k.categoryChineseCount}
        />
        <KnowledgeCategoryTile
          href="/wiedza/planety"
          icon={Orbit}
          title={k.sectionPlanets}
          hint={k.categoryPlanetsHint}
          count={k.categoryPlanetsCount}
        />
        <KnowledgeCategoryTile
          href="/wiedza/domy"
          icon={Home}
          title={k.sectionHouses}
          hint={k.categoryHousesHint}
          count={k.categoryHousesCount}
        />
        <KnowledgeCategoryTile
          href="/wiedza/aspekty"
          icon={Waypoints}
          title={k.sectionAspects}
          hint={k.categoryAspectsHint}
          count={k.categoryAspectsCount}
        />
        <div className="col-span-2">
          <KnowledgeCategoryTile
            href="/wiedza/zywiol"
            icon={Flame}
            title={k.sectionElements}
            hint={k.categoryElementsHint}
            count={k.categoryElementsCount}
          />
        </div>
      </div>
    </section>
  )
}
